import Vue from 'vue';
import ThriftPlugin from '../plugins/thrift/thrift-plugin';

Vue.use(ThriftPlugin);

// eslint-disable-next-line import/prefer-default-export
export const thriftPlugin = Vue.prototype.$ThriftPlugin;
